'use client';

import Link from 'next/link';
import Logo from '../Logo';

/**
 * Site footer.
 *
 * Design reference: hairline top border on --sand, a 1360px column at 34px/72px
 * padding, the reduction lockup on the left and domain / Contact / Back to top
 * on the right.
 *
 * The previous footer linked to /work/*, /journey and four blog slugs. Every
 * one of those is either deleted by this ticket or 404s against the empty blog
 * API, so the link set is replaced rather than restyled.
 */
export default function Footer() {
  const scrollToTop = (e: React.MouseEvent) => {
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="border-t border-line bg-sand">
      <div className="mx-auto flex max-w-[1360px] flex-col items-center gap-4 px-6 py-6 text-center md:flex-row md:justify-between md:gap-0 md:px-[72px] md:py-[34px] md:text-left">
        <Logo size={20} showText={true} textSize={16} />

        <div className="flex flex-wrap items-center justify-center gap-x-7 gap-y-2 font-sans text-sm text-caption">
          <span>focalpoint-ai.com</span>
          <Link href="/contact" className="text-ink-blue underline-offset-[3px] hover:underline">
            Contact
          </Link>
          <a
            href="#"
            onClick={scrollToTop}
            className="text-ink-blue underline-offset-[3px] hover:underline"
          >
            Back to top
          </a>
        </div>
      </div>
    </footer>
  );
}
